import { useState } from 'react';
import { toast } from 'sonner';
import { invField, errMsg } from './invApi';

export const NewPartForm = ({ api, orderId, initialName = '', onParts, onClose }) => {
  const [f, setF] = useState({ name: initialName, part_number: '', quantity: 1 });
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      const r = await api.post(`/work-orders/${orderId}/new-part`, { ...f, quantity: Number(f.quantity) || 1 });
      onParts(r.parts);
      toast.success(`${f.name} inscrite au bon et à l'inventaire. Scannez la facture à la réception pour compléter.`);
      onClose();
    } catch (e) { toast.error(errMsg(e)); }
    finally { setBusy(false); }
  };
  return (
    <div className="bg-slate-800/60 border border-amber-500/20 rounded-lg p-3 space-y-2" data-testid="new-part-form">
      <p className="text-[11px] text-slate-300">Pièce pas encore dans l'inventaire : inscrivez-la. Elle sera marquée « à commander » jusqu'à la réception de la facture.</p>
      <div className="flex flex-wrap gap-2">
        <input className={`${invField} flex-1 min-w-[140px] text-xs`} placeholder="Nom de la pièce" value={f.name} onChange={e => setF({ ...f, name: e.target.value })} data-testid="new-part-name" />
        <input className={`${invField} w-28 text-xs`} placeholder="No pièce" value={f.part_number} onChange={e => setF({ ...f, part_number: e.target.value })} data-testid="new-part-pn" />
        <input type="number" min="1" className={`${invField} w-16 text-xs`} value={f.quantity} onChange={e => setF({ ...f, quantity: e.target.value })} data-testid="new-part-qty" />
      </div>
      <div className="flex gap-3">
        <button onClick={save} disabled={busy || !f.name.trim()} className="px-3 py-1.5 rounded-lg bg-amber-500 text-black text-xs font-semibold disabled:opacity-40" data-testid="new-part-save">Inscrire la pièce</button>
        <button onClick={onClose} className="text-xs text-slate-400" data-testid="new-part-cancel">Annuler</button>
      </div>
    </div>
  );
};
